export interface Message<T = any> {
  isRantion: boolean;
  data: {
    type: DoType;
    value: T;
  };
}
type DoType = "openOss";

export function listenerGlobalPostMessage() {
  window.addEventListener("message", (event: MessageEvent<Message<string>>) => {
    const { isRantion, data } = event.data;
    if (isRantion && data) {
      if (typeFunc[data.type]) typeFunc[data.type](data.value);
    }
  });
}

const typeFunc = {
  openOss: (value: string) => {
    window.open(value, "_blank");
  },
};
